// extracted by mini-css-extract-plugin
module.exports = {"fullHeightContainer":"HomePageSeedComponent_fullHeightContainer__2epp8","flexRow":"HomePageSeedComponent_flexRow__38pAc","staticRow":"HomePageSeedComponent_staticRow__3FRTt"};